/*
 * Copyright (c) 2024 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { AnvilorFormsAppStoreContext } from "../anvilor-forms-app-store.service";
import { AnvilorFormsAppStore } from "../anvilor-forms-app-store.service";
import { RecaptchaService } from "../../services/google-recaptcha.service";
import { Observable } from "rxjs";
import { map } from "rxjs";
import { combineLatest } from "rxjs";

export class AnvilorFormsAppCaptcha {
  private store: AnvilorFormsAppStore;
  private googleRecaptcha: RecaptchaService;

  readonly captchaRequired$: Observable<boolean>;
  readonly grecaptchaResponse$: Observable<string | undefined>;
  readonly captchaSolved$: Observable<boolean>;
  readonly canSubmit$: Observable<boolean>;

  constructor(ctx: AnvilorFormsAppStoreContext) {
    this.store = ctx.store;
    this.googleRecaptcha = ctx.recaptcha;

    this.grecaptchaResponse$ = this.store.select(
      (state) => state.grecaptcha_v2_response
    );
    this.captchaRequired$ = this.store.select(
      (state) => state.anvilor_form_config?.require_captcha ?? false
    );
    this.captchaSolved$ = this.grecaptchaResponse$.pipe(map((response) => !!response));
    this.canSubmit$ = combineLatest([this.captchaRequired$, this.captchaSolved$]).pipe(
      map(([required, solved]) => !required || solved)
    );
  }

  async renderWidget(el: Element): Promise<void> {
    await this.googleRecaptcha.renderChallengeWidget(el, {
      onSolved: (grecaptcha_response) =>
        this.store.patchState({ grecaptcha_v2_response: grecaptcha_response }),
      onError: () => this.store.patchState({ grecaptcha_v2_response: undefined }),
      onExpired: () => this.store.patchState({ grecaptcha_v2_response: undefined }),
    });
  }
}
